import { Component, OnInit, ViewChild, TemplateRef, AfterViewChecked } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchObjectResult } from '../../../models/SearchObject';
import { CreditSearchCritertia } from '../shared/CreditSearchCritertia';
import { OrdersService } from '../shared/orders.service';
import { DataTableColumn } from '../../../shared/data-table/data-table.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-credits',
    templateUrl: './credits.component.html',
    styleUrls: ['./credits.component.scss'],
    standalone: false
})
export class CreditsComponent implements OnInit {

  loadPage: (page: number, pageSize: number) => Observable<SearchObjectResult<Event>> = null;
  filters: CreditSearchCritertia = {};

  @ViewChild('contractId', { static: true })
  contractId: TemplateRef<any>;

  @ViewChild('creditCode', { static: true })
  creditCode: TemplateRef<any>;

  @ViewChild('creditTitle', { static: true })
  creditTitle: TemplateRef<any>;

  @ViewChild('createdDate', { static: true })
  createdDate: TemplateRef<any>;

  @ViewChild('consumedDate', { static: true })
  consumedDate: TemplateRef<any>;

  @ViewChild('amount', { static: true })
  amount: TemplateRef<any>;

  @ViewChild('consumed', { static: true })
  consumed: TemplateRef<any>;

  @ViewChild('remaining', { static: true })
  remaining: TemplateRef<any>;

  @ViewChild('expiredDate', { static: true })
  expiredDate: TemplateRef<any>;

  @ViewChild('status', { static: true })
  status: TemplateRef<any>;

  @ViewChild('actions', { static: true })
  actions: TemplateRef<any>;

  columns: DataTableColumn[] = [];

  public creditClosingDate: Date = new Date();
  public creditClosingTime: Date = new Date();
  public consumedAmount: number = 0;

  public currentPage: number;
  public pageSize: number;

  public accountType;
  public accountId: number;

  public currentCreditCode: string;
  public currentCreditTitle: string;

  public showAmountError = false;

  constructor(private _ordersService: OrdersService, private _modalService: NgbModal, private _snackBar: MatSnackBar, private _translate: TranslateService) {
    this.loadPage = (page: number, pageSize: number) => this._ordersService.search(page, pageSize, this.filters);
    this.accountType = this.getAccountType();
    this.accountId = parseInt(localStorage.getItem('accountId'));
  }

  ngOnInit() {
    this.columns = [
      {
        name: 'creditId',
        displayed: true,
        translationKey: 'orders.credits.creditId',
        template: this.contractId,
        sortable: true,
        excel: {
          objectRef: ['creditId']
        }
      },
      {
        name: 'creditCode',
        displayed: true,
        translationKey: 'orders.credits.creditCode',
        template: this.creditCode,
        sortable: true,
        excel: {
          objectRef: ['creditCode']
        }
      },
      {
        name: 'creditTitle',
        displayed: true,
        translationKey: 'orders.credits.clientName',
        template: this.creditTitle,
        sortable: true,
        excel: {
          objectRef: ['creditTitle']
        }
      },
      {
        name: 'createdDate',
        displayed: true,
        translationKey: 'orders.credits.createdDate',
        template: this.createdDate,
        sortable: true,
        excel: {
          objectRef: ['createdDate'],
          pipe: 'date'
        }
      },
      {
        name: 'consumedDate',
        displayed: true,
        translationKey: 'orders.credits.consumedDate',
        template: this.consumedDate,
        sortable: true,
        excel: {
          objectRef: ['consumedDate'],
          pipe: 'date'
        }
      },
      {
        name: 'amount',
        displayed: true,
        translationKey: 'orders.credits.amount',
        template: this.amount,
        sortable: true,
        excel: {
          objectRef: ['amount'],
          pipe: 'currency'
        }
      },
      {
        name: 'consumed',
        displayed: true,
        translationKey: 'orders.credits.consumed',
        template: this.consumed,
        sortable: true,
        excel: {
          objectRef: ['consumed'],
          pipe: 'currency'
        }
      },
      {
        name: 'remaining',
        displayed: true,
        translationKey: 'orders.credits.remaining',
        template: this.remaining,
        sortable: true,
        excel: {
          objectRef: ['remaining'],
          pipe: 'currency'
        }
      },
      {
        name: 'expiredDate',
        displayed: true,
        translationKey: 'orders.credits.expiredDate',
        template: this.expiredDate,
        sortable: true,
        excel: {
          objectRef: ['expiredDate']
        }
      },
      {
        name: 'status',
        displayed: true,
        translationKey: 'orders.credits.status',
        template: this.status,
        sortable: true,
        excel: {
          objectRef: ['status'],
          pipe: 'creditsStatus'
        }
      },
      {
        name: 'actions',
        displayed: true,
        translationKey: '',
        template: this.actions,
        sortable: true,
        additionalClass: 'text-right',
        trAddidionalClass: 'text-right'
      },
    ];
  }

  public onCreditCloseButtonClick(content, creditId, creidtCode, creditTitle) {
    this.currentCreditCode = creidtCode;
    this.currentCreditTitle = creditTitle;
    this.creditClosingDate = new Date();
    this._modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: false }).result.then((modalAction) => {
      const closeDate = moment(this.creditClosingDate).format('YYYY-MM-DD') + " " + moment(this.creditClosingTime).format('HH:mm');
      const today = new Date();
      this._ordersService.closeCredit(creditId, this.creditClosingDate, this.creditClosingTime, this.consumedAmount, this.accountId).subscribe(result => {
        this._snackBar.open(this._translate.instant('orders.credits.messageConsumed'), '', {
          duration: 3500,
        });
        this.loadPage = (page: number, pageSize: number) => {
          this.currentPage = page;
          this.pageSize = pageSize;
          return this._ordersService.search(page, pageSize, this.filters);
        };
      });
    });
  }

  private getAccountType() {
    if (localStorage.isClient === 'false' && localStorage.isRentalPoint === 'false') {
      return 'admin';
    }
    if (localStorage.isClient === 'true' && localStorage.isRentalPoint === 'false') {
      return 'client';
    }
    if (localStorage.isClient === 'false' && localStorage.isRentalPoint === 'true') {
      return 'rentalPoint';
    }
  }

  public closeModal(modal) {
    if (this.consumedAmount <= 0) {
      this.showAmountError = true;
      return;
    }
    this.showAmountError = true;
    modal.close();
  }

}
